// Initial state
const state = {
  loading: false,
  notification: {
    show: false,
    message: '',
    type: 'info', // info, success, warning, danger
    timeout: 3000
  }
}

// Getters
const getters = {
  isLoading: state => state.loading,
  notification: state => state.notification
}

// Actions
const actions = {
  // Show loading indicator
  setLoading({ commit }, isLoading) {
    commit('SET_LOADING', isLoading)
  },

  // Show notification
  showNotification({ commit }, { message, type = 'info', timeout = 3000 }) {
    commit('SET_NOTIFICATION', { show: true, message, type, timeout })

    // Auto-hide notification after timeout
    if (timeout > 0) {
      setTimeout(() => {
        commit('SET_NOTIFICATION', { show: false, message: '', type: 'info', timeout: 3000 })
      }, timeout)
    }
  },

  // Hide notification manually
  hideNotification({ commit }) {
    commit('SET_NOTIFICATION', { show: false, message: '', type: 'info', timeout: 3000 })
  }
}

// Mutations
const mutations = {
  SET_LOADING(state, isLoading) {
    state.loading = isLoading
  },
  SET_NOTIFICATION(state, notification) {
    state.notification = notification
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
